import { Component as ReactComponent } from 'react';
import { PropTypes } from 'prop-types';

import './styles.scss';

export class InfoItem extends ReactComponent {

    render() {
        const self = this;

        if (Boolean(self.props.vertical)) {
            return (
                <div className="infoitem d-flex flex-column">
                    <div>{self.props.caption}</div>
                    <div className="w-100">{self.props.content || <span>&nbsp;</span>}</div>
                </div>
            )
        }
        else {
            return (
                <div className="infoitem d-flex align-items-baseline">
                    <div>{self.props.caption}</div>
                    <div className="flex-grow-1">{self.props.content || <span>&nbsp;</span>}</div>
                </div>
            )
        }
    }
}
InfoItem.propTypes = {
    vertical: PropTypes.bool
}
InfoItem.defaultProps = {
    versical: false
}